import React from "react";
export var CtaButton = function (_a) {
    var className = _a.className, label = _a.label, value = _a.value;
    return (React.createElement("div", { className: className },
        React.createElement("a", { href: value, className: "py-2 px-7 max-w-full uppercase text-primary-200 text-sm font-semibold tracking-widest border border-primary-200 rounded-3xl" }, label)));
};
//# sourceMappingURL=CtaButton.js.map